import React, { useState } from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idQuizUpdate, setPublicOptionQuiz } from '../../../adminSlice';

const InputFormsForQuizes  = (props) => {

            
        const [userInputContent, setUserInputContent] = useState('');
        const [userInputDescription, setUserInputDescription] = useState('');
        const [userInputCategory, setUserInputCategory] = useState();
        const [userInputValue, setUserInputValue] = useState();
        const [publicQuiz, setPublicQuiz] = useState(false);
          


  
 // CLICK OK
const onSend = () => {
        const { dispatch } = props;

        const item = {
            quiz_id: props.adminState.selectedId,
            quiz_name: userInputContent,
            quiz_description: userInputDescription,
            quiz_category: userInputCategory,
            quiz_value: userInputValue,
          
            
        }
        console.log(item);
        dispatch(idQuizUpdate(item)); 
        setUserInputContent('');
        setUserInputDescription('');
        setUserInputCategory();
        setUserInputValue();
        setPublicQuiz(false);
        document.getElementById("select-subcategory-input").selectedIndex = 0;
        document.getElementById("select-quiz-input").selectedIndex = 0; 
};


// ENTER INPUT
const handleUserInputContent = (e) => {
    setUserInputContent(e.target.value);

};
const handleUserInputDescription = (e) => {
    setUserInputDescription(e.target.value);

};
 //HANDLE CATEGORY
 const handleCategory = (event) => {
    setUserInputCategory(event.target.options[event.target.selectedIndex].value);
          
 };
  //HANDLE VALUE
const  handleValue = (event) => {
    setUserInputValue(event.target.options[event.target.selectedIndex].value);
            
};

// CLOSE FORM
const onClose = () => {
    const { dispatch } = props;
    dispatch(closeInputForms());
    setUserInputContent('');
    setUserInputDescription('');
    setUserInputCategory();
    setUserInputValue();
    setPublicQuiz(false);
    document.getElementById("select-subcategory-input").selectedIndex = 0;
    document.getElementById("select-quiz-input").selectedIndex = 0;

};
 // CLICK SAVE
const onSave = () => {
        const { dispatch } = props;

        const item = {
            quizId: props.adminState.selectedId,
            publicOption: publicQuiz,
            
        }
        console.log(item);
        dispatch(setPublicOptionQuiz(item));
        setPublicQuiz(false); 

       dispatch(closeInputForms()); 
};
//CHECK PUBLIC
const handleSetPublicOption = () => {
    setPublicQuiz(!publicQuiz);

};

    
        //console.log(this.props.adminState.openInputForms);
     if (props.adminState.openInputFormsForQuizes) {
        return(
            <div className="InputFormsForQuizes">
                <p>Изменить данные теста:</p>
                <p  className="p-text">id: {props.adminState.selectedId}</p>
                <p  className="p-text">Старое название: {props.adminState.dataQuizesId.map(item => {
               //console.log(this.props.adminState.selectedId)
                if (item.id === Number(props.adminState.selectedId))
                //{ console.log(item.text)}
                {return item.text;} else return null;
                })}
                </p>
                <p  className="p-text">Описание: {props.adminState.dataQuizesId.map(item => {
               //console.log(this.props.adminState.selectedId)
                if (item.id === Number(props.adminState.selectedId))
                //{ console.log(item.text)}
                {return item.quiz_description;} else return null;
                })}
                </p>
                


             
             <form>
                 <label>
                     Новое название теста: </label>
                 <textarea onChange={handleUserInputContent}
                  
                 ></textarea>
                 
                 <label>
                     Новое описание теста: </label>
                 <textarea  onChange={handleUserInputDescription}
                  
                 ></textarea>
                 
                 <label htmlFor="category">Категория</label>
                        <select name="category" id='select-subcategory-input' defaultValue={'Default'} value={userInputCategory} onChange={handleCategory}>
                       
                            <option disabled  value="Default">Выбрать категорию</option>
                            <option value="3" >Железобетонные конструкции</option>
                            <option value="2">Стальные конструкции</option>
                            <option value="1">Деревянные конструкции</option>
                            <option value="9">Основания и фундаменты</option>
                            <option value="7">Другое</option>
                        </select>
                        
                        <label htmlFor="value-quiz">Баллы</label>
                        <select name="value-quiz" id='select-quiz-input' defaultValue={'Default'} value={userInputValue} onChange={handleValue} >
                            <option disabled  value="Default">Выбрать баллы</option>
                            <option value="5" >100</option>
                            <option value="4">80</option>
                            <option value="3">50</option>
                            <option value="2">30</option>
                            <option value="1">10</option>
                            

                        </select>

             </form>
             
                        
                        

             <button onClick={onSend}>OK</button>
              <div className="container-row">
                                    <input  className="check-box" type="checkbox" id="checkboxQuiz"
                                    onChange={handleSetPublicOption} 
                                    ></input>
                                    <p>(public)</p>
                </div> 
                <button  onClick={onSave}>Сохранить</button>
             <button onClick={onClose}>Закрыть</button>
            </div>
        )
     } else return null;
       
     

        
    
}

export default InputFormsForQuizes;